import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Divider,
} from "@mui/material";

const VendingAtmAboutUsPage = () => {
  return (
    <Box sx={{ bgcolor: "#f9fafb", color: "#1a1a1a", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="md">
        {/* Title */}
        <Typography
          variant="h2"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ mb: 4, fontSize: { xs: "2rem", md: "3rem" } }}
        >
          Our Story: A Family Venture
        </Typography>

        {/* Introduction */}
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          If you’ve heard about our vending and ATM services, you’re in for a tale of transforming businesses with convenience and allure. This isn’t just a company—it’s our family’s passion. Take a moment, and let us share what fuels our drive.
        </Typography>

        {/* Main Narrative */}
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          We’re a family-run team, through and through. No corporate overlords, no distant investors—just a dedicated crew committed to elevating your business. Adding vending machines and ATMs is more than a service; it’s a way to make your property a magnet for customers. We obsess over the details, from strategic placement to seamless operations, so your business thrives effortlessly. Our clients are our partners, and we’re all in on their success.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Communication is our cornerstone. Fed up with “no-reply” emails or endless hold times? That’s not us. Reach out, and you’ll get a real person—same day, often within hours. Call, email, whatever suits you. Our contact info is on every page of our site, and we ditch the automated runaround. No bots, no menus—just someone who knows your needs and cares about your questions. We’ve never sidestepped a client, and we’re not about to start.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          We keep it straightforward and fair. No hidden fees, no surprises, just a service you’ll want to rave about. We place vending machines and ATMs in high-traffic spots to draw more visitors, keep your customers happy with instant snacks, drinks, or cash, and encourage them to spend more at your business. Whether it’s a bar where patrons linger longer or a nightclub buzzing with activity, we make your space work harder. We handle placement, restocking, and support, so you can focus on what you do best.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* Core Values */}
        <Typography
          variant="h4"
          fontWeight={600}
          gutterBottom
          sx={{ mb: 3 }}
        >
          What We Stand For
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 2 }}>
          <strong>Family First.</strong> As a family business, we infuse every partnership with trust and care. Your growth is our victory.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 2 }}>
          <strong>Always Listening.</strong> We’re here for you. Every call, email, or question gets our full attention, every time.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          <strong>Stress-Free Service.</strong> We streamline vending and ATM management, unlocking your business’s potential without the hassle.
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Why this approach? Because we’ve faced companies that vanish when you need them or prioritize profits over people. We’re building something different: a business rooted in integrity, open communication, and delighted clients. It’s not about trends or shortcuts—it’s about doing right by you, every single day.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* Call to Action */}
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            fontWeight={600}
            gutterBottom
            sx={{ mb: 3 }}
          >
            Ready to Join Our Family?
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 600, mx: "auto" }}
          >
            Let’s transform your business with vending machines and ATMs that drive traffic and delight customers. Reach out today to start our partnership.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="mailto:contact@globalga.co?subject=Vending%20&%20ATM%20Partnership%20Inquiry"
            sx={{
              px: 6,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              bgcolor: "#1976d2",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s, box-shadow 0.3s",
              "&:hover": {
                bgcolor: "#1565c0",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            Get in Touch
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default VendingAtmAboutUsPage;